module.exports = __webpack_public_path__ + "img/20_53.d60a7fe7.png";